<template>
  <div class="postavitev-infoj">
    <div>
      <div class="info-okvir  brez-odmika-spoda">
        <div class="postavitev-info-icone">
          <i class="fa fa-info-circle"></i>
        </div>
        <div class="postavitev-info-tekst">
          <p class="modra-barva-info">
            Spremembe vročanja računov v spletno banko ali direktne bremenitve (SEPA) zaradi prenosa podatkov v
            bančne sisteme niso izvedljive do 18. dne v tekočem mesecu.
            Za spremembo transakcijskega računa (TRR) je potrebno najprej preklicati vklopljeno SEPO ali vročanje
            v spletno banko in nato vnesti novo številko ali druge podatke TRR-ja.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaCasovnicaSprememb'
}
</script>

<style src="../../../../../../static/css/MojT-2/Eposlovanje/InfoKomplonentaCasovnicaSprememb.css" scoped>
.brez-odmika-spodaj {
  padding-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje/InfoKomponentaCasovnicaSprememb.vue